import { HeaderDataType } from "./data";
import { Icon } from "@iconify/react";

export function Header({ heading, characteristics, icons }: HeaderDataType) {
  return (
    <div className="flex flex-col items-center justify-center bg-gradient-to-t from-blue-950 to-blue-500 p-5 rounded-t-lg text-white h-auto">
      <div className="text-2xl font-bold mb-6 text-center">{heading}</div>
      <div className="flex flex-wrap gap-6 items-center justify-center">
        {characteristics.map((characteristic, index) => (
          <div
            key={characteristic}
            className="bg-white text-black px-4 py-2 rounded-md text-sm text-center min-w-[250px] h-[45px] md:h-[60px] flex items-center justify-center gap-4 md:mb-4"
          >
            {icons[index] && icons[index] !== "" && (
              <Icon
                icon={icons[index]}
                className="text-gray-700 placeholderLoader "
                height={20}
              />
            )}
            <p className="text-sm font-semibold flex">{characteristic}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
